module.exports = __webpack_public_path__ + "img/pic5.dc8bf8c2.png";